import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import PaymentIcon from "@mui/icons-material/Payment";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import { CircularProgress, IconButton } from "@mui/material";
import { FormikProvider, Form, useFormik, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../../config/firebase";
import { useDispatch } from "react-redux";
import { createPayment, getPayments } from "../../apiCalls/userApiCalls";
import { addpaymentsFailure } from "../../redux/reduxSlice/paymentRedux";
import { errNotification, successNotification } from "../common/notification";
import { ToastContainer } from "react-toastify";

const MonthsArr = [
  "JANUARY ",
  "FEBRUARY ",
  "MARCH ",
  "APRIL ",
  "MAY ",
  "JUNE ",
  "JULY ",
  "AUGUST ",
  "SEPTEMBER ",
  "OCTOBER ",
  "NOVEMBER ",
  "DECEMBER ",
];

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://mui.com/">
        S2A Academy
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const theme = createTheme();

export default function PaymentForm(props) {
  const [file, setFile] = React.useState(null);
  const [errFile, setErrFile] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);
  const dispatch = useDispatch();
  const { userId, month, year, classType, status } = props.paymentObj;
  const user = JSON.parse(sessionStorage.getItem("user"));

  async function uploadData(values, setIsLoading) {
    const fileName = `slip/${new Date().getTime()} - ${file.name}`;
    const storageRef = ref(storage, fileName);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("Upload is " + progress + "% done");
        switch (snapshot.state) {
          case "paused":
            console.log("Upload is paused");
            break;
          case "running":
            console.log("Upload is running");
            break;
          default:
        }
      },
      (error) => {
        console.log(error);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          console.log("File available at", downloadURL);

          const data = {
            slipurl: downloadURL,
            userId,
            month,
            year,
            classType,
          };
          createPayment(data, dispatch)
            .then((res) => {
              successNotification("Add Payment Success!!!");
              getPayments(user?._id, dispatch);
              setIsLoading(false);
              setTimeout(() => {
                props.handleClose();
              }, 2000);
            })
            .catch((err) => {
              dispatch(addpaymentsFailure());
              setIsLoading(false);
              errNotification("Add Payment Failed!!!");
            });
        });
      }
    );
  }

  const validationSchema = Yup.object().shape({
    classId: Yup.string().min(4).required("ClassID is required"),
    email: Yup.string().email("Email is invalid").required("Email is required"),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
      classId: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        const payload = {
          email: values.email,
          classId: values.classId,
        };
        if (file) {
          setIsLoading(true);
          uploadData(payload, setIsLoading);
        } else {
          setErrFile("Please Upload Slip");
        }
      } catch (error) {
        setIsLoading(false);
        errNotification("Add Payment Failed!!!");
      }
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <ToastContainer />
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            <PaymentIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Monthly Payment
          </Typography>
          <Typography component="h3" variant="h6">
            {MonthsArr[month]} {year}
          </Typography>
          {/* start form    */}
          <React.Fragment>
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <React.Fragment>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={12}>
                      <TextField
                        id="email"
                        label="email"
                        fullWidth
                        variant="standard"
                        name="email"
                        autoCapitalize="off"
                        onChange={formik.handleChange}
                        value={formik.values.email}
                      />
                      <ErrorMessage name="email">
                        {(msg) => (
                          <div
                            style={{
                              color: "red",
                              textAlign: "left",
                              fontSize: "12px",
                            }}
                          >
                            {msg}
                          </div>
                        )}
                      </ErrorMessage>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <TextField
                        id="classId"
                        label="Class ID"
                        fullWidth
                        variant="standard"
                        type="text"
                        name="classId"
                        autoComplete="off"
                        onChange={formik.handleChange}
                        value={formik.values.classId}
                      />
                      <ErrorMessage name="classId">
                        {(msg) => (
                          <div
                            style={{
                              color: "red",
                              textAlign: "left",
                              fontSize: "12px",
                            }}
                          >
                            {msg}
                          </div>
                        )}
                      </ErrorMessage>
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      mt: 2,
                    }}
                  >
                    <Button
                      variant="outlined"
                      component="label"
                      sx={{
                        mt: 2,
                      }}
                    >
                      Upload Slip
                      <input
                        type="file"
                        hidden
                        onChange={(e) => setFile(e.target.files[0])}
                      />
                    </Button>
                    <div
                      style={{
                        color: "red",
                        textAlign: "left",
                        fontSize: "12px",
                      }}
                    >
                      {errFile}
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="h10">
                      <div style={{ color: "blue", fontSize: "16px" }}>
                        {file && file.name}
                      </div>
                    </Typography>
                  </Grid>
                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      variant="contained"
                      sx={{ mt: 2, ml: 1, width: "150px" }}
                      type="submit"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : (
                        "Add Payment"
                      )}
                    </Button>
                  </Box>
                </React.Fragment>
              </Form>
            </FormikProvider>
          </React.Fragment>
          {/* end form */}
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </ThemeProvider>
  );
}
